module.exports = __webpack_public_path__ + "img/design.d815b4af.webp";